module.exports = __webpack_public_path__ + "static/img/icon_success.37268d51.png";